import RushAboutPage from '../landing/rush/RushAboutPage';

const AboutPageWrapper = () => <RushAboutPage />;

export default AboutPageWrapper;
